import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import vue from 'vue'

export async function postLog(data = {}) {
  console.log('postLog')
  let response = {}
  if (Utils.isEmptyObject(data.name) || Utils.isEmptyObject(data.action)) {
    console.error('iisi postLog: data is null')
    return response
  }

  try {
      response = await vue.http.post(`/api/Log/WriteUserLog`, data)

  } catch (err) {
      console.error('iisi postLog: ', err)
      return response
  }

  Utils.setApiResponsSuccess(response)
  return response
}